import List from "./List";

const files = {
  list: List,
};

export default files;
